export const actionTypePrefix = '@@BirthdayPopup';
export const reduxKey = '@@BirthdayPopup';
